import { RootState } from "redux/rootReducer";

export const selectIsLoadingConsultationDetails = (state: RootState) =>
  state.consultationDetails.loading;
export const selectConsultationDetailsErrorMessage = (state: RootState) =>
  state.consultationDetails.error;
export const consultationDetailsDataResponse = (state: RootState) =>
  state.consultationDetails.consultationDetailsResponse;
